import type { VitrineLargeProps } from '../types'

export const isDarkTheme = (theme: VitrineLargeProps['theme']) =>
  theme === 'dark'
